import React from "react";
import styled from "styled-components";
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";

import LocalStorage from "../../Helpers/LocalStorage";
import { useTranslate } from '@tolgee/react';


import { useAuthService } from '../../Context/AuthContext'; 


const FirstTimeUsingMessage = ({ setShowFirstUseMessage }) => {
  
  const { user } = useAuthService();

  const handleClose = () => {
    LocalStorage.setFirstMessageRead(true);
    setShowFirstUseMessage(true); 
  };
  
  const { t } = useTranslate();
  
  
  const isSubscribed = user?.is_pro || user?.is_pro_from_platform;
  const shouldShowProTip = !isSubscribed; 

  return (
    <Container>
      <CloseBtn onClick={handleClose}>
        <CloseIcon />
      </CloseBtn>
      <Line>
        <Title>{t('first_time_usage.title')}</Title>
      </Line>
      <Line>
        <Text>{t('first_time_usage.subtitle')}</Text>
      </Line>

      
      <Group>
        <Text>
          <span>{t('first_time_usage.step1Span')}</span>:{" "}
          {t('first_time_usage.step1')}
        </Text>
        <Text>
          <span>{t('first_time_usage.step2Span')}</span>:{" "}
          {t('first_time_usage.step2')}
        </Text>
        <Text>
          <span>{t('first_time_usage.step3Span')}</span>:{" "}
          {t('first_time_usage.step3')}
        </Text>
      </Group>

      
      {shouldShowProTip && (
        <Line>
          <Text>
            <span>{t('first_time_usage.proTipSpan')}</span>:{" "}
            {t('first_time_usage.proTip')}
          </Text>
        </Line>
      )}

      <Line>
        <Text>{t('first_time_usage.enjoy')}</Text>
      </Line>
    </Container>
  );
};

export default FirstTimeUsingMessage;


const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: ${({ theme }) => theme.first_time_message.background};
  padding: 20px;
  margin: 5px 16px;
  border-radius: 4px;
  box-shadow: 0px 0px 11.3px 0px
    ${({ theme }) => theme.first_time_message.background};
  position: relative;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;
const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-left: auto;
  max-width: 24px;
  position: absolute;
  top: -10px;
  right: -10px;

  svg {
    color: ${({ theme }) => theme.menu.selectedOpionBackground};
    stroke: ${({ theme }) => theme.sidebar.borderColor};
  }
`;
const Title = styled.h1`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }) => theme.menu.primaryTextColor};

  span {
    color: ${({ theme }) => theme.premium_green};
    font-weight: 600;
  }
`;